import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FIELD_WIDTHS,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  LOCAL_STORAGE,
  PHONE_TRANSLATIONS
} from "@/shared/constants/FormConstants";
import { Http } from "@status/codes";
import { nanoid } from "nanoid";
import {
  FIELD_GROUP_CONSTANTS,
  INFO_GROUP_VALIDATORS,
  FIELD_TYPE,
  VISUAL_ELEMENT_TYPE,
  DATA_TYPE,
  DATA_TYPE_SIMPLE,
  INFO_GROUP_CONSTANTS,
  TYPE_BASE
} from "../../../modules/InfoGroup/constants/InfoGroupConstants";
import { FieldGroup } from "../../../modules/InfoGroup/models/FieldGroup";
import { ListService } from "@/modules/List/services/ListService";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { ListSchema } from "@/modules/List/models/ListSchema";
import { Option } from "@/modules/List/models/Option";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { PhoneSchema } from "../../models/PhoneSchema";
import { INFO_GROUP_EVENTS } from "../../../modules/InfoGroup/constants/InfoGroupConstants";
import { Icon } from "@/shared/models/Icon";
import _ from "lodash";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { ORDER_CONSTANTS } from "@/modules/Orders/constants/OrderConstants";
import { Schema } from "@/modules/FormTemplate/models/Schema";
import {
  ELEMENT_VOIDED,
  ERROR_NAME_DUPLICATE,
  ERROR_NO_LIST_SELECTED,
  FIELD_GROUP_INIT,
  FIELD_PREVIEW_TEXT,
  MIN_WIDTH_BASIC_SMALL_FIELD,
  MIN_WIDTH_LIST_SMALL_FIELD,
  NAME_KEY_CHART
} from "./constants/FieldGroupConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import {
  BASICO,
  COMPONENT_TAGS,
  GENERAL_CONSTANTS,
  INPUT_TYPES,
  MAXIMUM_VALUE,
  MINIMUM_VALUE,
  STATE,
  STRING_TYPE
} from "@/shared/constants/GeneralConstants";
import { DynamicSelectData } from "../DynamicSelect/model/DynamicSelectData";
import { ListQuery } from "@/modules/List/models/ListQuery";
import ModifVJsfInput from "./../ModifVJsfInput/ModifVJsfInput.vue";
import { PreventKey } from "@/shared/mixins/mixins";

Vue.use(Vuetify);
@Component({
  name: "AddFieldGroup",
  components: {
    ModifVJsfInput,
    DynamicSelect
  }
})
export default class AddFieldGroup extends PreventKey {
  @Inject() listService!: ListService;

  @Prop({ default: false }) dialogFieldGroup!: boolean;
  @Prop({ default: false }) private isEditingGroupField!: boolean;
  @Prop() private indexField!: number;
  @Prop({ default: 0 }) clearData!: number;
  @Prop() fieldsGroup!: FieldGroup[];
  @Prop() phoneTypeList!: PhoneSchema[];
  @Prop() idEditing!: string;
  @Prop() private iconsList!: Icon[];
  @Prop() addFieldsKey!: number;
  @Prop({ default: () => true }) addListButton!: boolean;

  fieldGroupForm = false;
  enumValues: Array<string> = [];
  listValues: Array<ListSchema> = [];
  dataTypeList = [{ label: "", value: "" }];
  visualElementList: { label: string; value: string }[] = [];
  enumValue = "";
  fieldTypeList = FIELD_TYPE;
  blankSpaces = [FORM_VALIDATORS.NOT_BLANK_SPACES];
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  phoneValidator = [
    FORM_VALIDATORS.NOT_BLANK_SPACES,
    INFO_GROUP_VALIDATORS.MAX_LENGTH
  ];
  requiredNotEmptySpaceAndField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  maxLength = [INFO_GROUP_VALIDATORS.MAX_LENGTH];
  listDisabledField = false;
  phoneDisabledField = false;
  order = 0;
  model = {};
  schema = {
    type: "object",
    properties: {
      field: {}
    },
    "x-cols": { md: 12 },
    "x-options": {
      tooltipProps: { openOnHover: false, openOnClick: true, right: true }
    }
  };
  field: FieldGroup = FIELD_GROUP_INIT;

  fieldGroupModalTitle = FIELD_GROUP_CONSTANTS.ADD_FIELD_TITLE;
  showMoreInfo = false;

  phoneTypeListTemp: PhoneSchema[] = [];

  minValue = [(v: any) => (v && v >= 0) || MINIMUM_VALUE];
  maxValue = [(v: any) => (v && v >= 1) || MAXIMUM_VALUE];
  minStepValue = [(v: any) => (v && v >= 1) || MAXIMUM_VALUE];
  sliderMaxValueMinimum = 1;
  minLessThanMax = [FORM_VALIDATORS.MIN_LESS_THAN_MAX];
  CONDITION_MINIMUM_MIN_VALUE =
    FORM_TEMP_CONSTANTS.CONDITION_SLIDER_FIELD.MINIMUM_MIN_VALUE;
  CONDITION_MINIMUM_MAX_VALUE =
    FORM_TEMP_CONSTANTS.CONDITION_SLIDER_FIELD.MINIMUM_MAX_VALUE;

  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  URL_ICON = FIELD_GROUP_CONSTANTS.LABEL.URL_ICON;
  HELP_TEXT = FIELD_GROUP_CONSTANTS.LABEL.HELP_TEXT;
  TITLE = FIELD_GROUP_CONSTANTS.LABEL.TITLE;
  CONV_TITLE = FIELD_GROUP_CONSTANTS.LABEL.CONVERSATION_TITLE;
  VISUAL_ELEM = FIELD_GROUP_CONSTANTS.LABEL.VISUAL_ELEM;
  MIN_VALUE = FIELD_GROUP_CONSTANTS.LABEL.MIN_VALUE;
  MAX_VALUE = FIELD_GROUP_CONSTANTS.LABEL.MAX_VALUE;
  STEP = FIELD_GROUP_CONSTANTS.LABEL.STEP;
  ADD_VALUES = FIELD_GROUP_CONSTANTS.LABEL.ADD_VALUES;
  SEARCH_LIST = FIELD_GROUP_CONSTANTS.LABEL.SEARCH_LIST;
  ADD_LIST = FIELD_GROUP_CONSTANTS.LABEL.ADD_LIST;
  FIELD_TYPE = FIELD_GROUP_CONSTANTS.LABEL.FIELD_TYPE;
  DATA_TYPE = FIELD_GROUP_CONSTANTS.LABEL.DATA_TYPE;
  VISIBLE = FIELD_GROUP_CONSTANTS.LABEL.VISIBLE;
  EDITABLE = FIELD_GROUP_CONSTANTS.LABEL.EDITABLE;
  REQUIRED = FIELD_GROUP_CONSTANTS.LABEL.REQUIRED;
  HINT = FIELD_GROUP_CONSTANTS.LABEL.HINT;
  HINT_LIST = FIELD_GROUP_CONSTANTS.LABEL.HINT_LIST;
  HINT_SEARCH_LIST = FIELD_GROUP_CONSTANTS.LABEL.HINT_SEARCH_LIST;
  VISIBLE_DASHBOARD = ORDER_CONSTANTS.LABELS.DASHBOARD_VISIBLE;
  EDITABLE_DASHBOARD = ORDER_CONSTANTS.LABELS.DASHBOARD_EDITABLE;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  FIELD_CONFIG = FORM_TEMP_CONSTANTS.LABEL.FIELD_CONFIG;
  FIELD_INFO = FORM_TEMP_CONSTANTS.LABEL.INFO_FIELD;
  MORE_INFO = FORM_CONSTANTS.BUTTON.MORE_INFO;
  FIELD_WIDTHS = FIELD_WIDTHS;
  FIELD_WIDTH = FORM_CONSTANTS.LABEL.FIELD_WIDTH;
  FIELD_PREVIEW_TEXT = FIELD_PREVIEW_TEXT;
  MIN_WIDTH_BASIC_SMALL_FIELD = MIN_WIDTH_BASIC_SMALL_FIELD;

  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  translations = PHONE_TRANSLATIONS;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  countriesPreferredList = INFO_GROUP_CONSTANTS.PREFERRED_COUNTRIES;
  ADD_LIST_LABEL = this.addListButton ? INFO_GROUP_CONSTANTS.ADD_LIST : "";

  formKey = 1;
  defaultCountry = "";
  switchValidation: { [key: string]: boolean } = {};

  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.SEARCH_LIST,
    hint: this.HINT_SEARCH_LIST,
    required: true
  };
  dynamicSelectList: DynamicSelectData[] = [];
  listKey = 0;

  async mounted() {
    this.defaultCountry = localStorage.getItem(LOCAL_STORAGE.COUNTRY) || "";
    this.switchValidation = {
      visible: this.field.visible,
      editable: this.field.editable,
      required: this.field.required,
      visibleDashboard: this.field.visibleDashboard || false,
      editableDashboard: this.field.editableDashboard || false
    };

    await this.loadListByName();
    await this.fillFormFieldGroup();
  }

  @Watch("field.visualElement")
  changeDataType() {
    if (
      this.field.visualElement &&
      this.field.visualElement !== FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING
    ) {
      this.field.schema.type =
        DATA_TYPE_SIMPLE[
          this.field.visualElement as keyof typeof DATA_TYPE_SIMPLE
        ];
    }
  }
  @Watch("dialogFieldGroup")
  cleanBeforeUse() {
    this.clearField();
    this.resetForm();
  }

  @Watch("fieldGroupForm")
  validateLengthOnRadioAndCheck() {
    if (
      COMPONENT_TAGS.includes(this.field.visualElement) &&
      this.field.type === BASICO
    ) {
      this.validateRadioAndCheckListValues();
    }
  }

  @Watch("enumValues")
  validateRadioAndCheckListValues() {
    const validation =
      this.field.schema.title.length > 0 &&
      this.enumValues.length > 0 &&
      this.field.visualElement.length > 0;
    this.fieldGroupForm = validation;
  }

  resetForm() {
    this.formKey = 1 - this.formKey;
  }

  async changeFieldType(isEditing?: boolean) {
    this.visualElementList =
      VISUAL_ELEMENT_TYPE[this.field.type as keyof typeof VISUAL_ELEMENT_TYPE];

    this.listDisabledField =
      this.field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.LIST;

    this.phoneDisabledField =
      this.field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE;
    if (
      this.listDisabledField &&
      this.dynamicSelectConfig.listAll.length == 0
    ) {
      await this.loadListByName();
    }
    if (isEditing) {
      this.dynamicSelectList = [];
      this.field.visualElement = "";
      this.listKey++;
      this.cleanOptions();
    }
  }

  changeElement(isEditing?: boolean) {
    this.dataTypeList =
      DATA_TYPE[this.field.visualElement as keyof typeof DATA_TYPE];
    if (isEditing) {
      this.listKey++;
      this.dynamicSelectList = [];
      this.field.schema.type = "";
      this.cleanOptions();
    }
  }

  saveListValue() {
    if (this.enumValue.trim()) {
      if (this.enumValues.includes(this.enumValue)) {
        Snackbar.popWarning(FORM_TEMP_CONSTANTS.MESSAGE.EXISTING_ITEM);
        return;
      }
      this.enumValues.push(this.enumValue);
      this.enumValue = "";

      this.field.schema = {
        ...this.field.schema,
        items: {
          enum: this.enumValues,
          type: FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING
        },
        enum: this.enumValues
      };
    }
  }

  deleteListValue(index: number) {
    this.enumValues.splice(index, 1);
  }

  saveFieldGroup() {
    const keyCode = `f${nanoid(8)}t`;
    this.field.conversationTitle =
      this.field.conversationTitle.trim() || this.field.schema.title.trim();
    const fieldKnow = this.fieldsGroup.find(field => {
      return (
        field.schema.title.trim() == this.field.schema.title.trim() &&
        field.key != this.field.key
      );
    });
    if (fieldKnow) {
      Snackbar.popError(ERROR_NAME_DUPLICATE);
      return;
    }

    this.field.schema = this.schema.properties.field as Schema;
    if (this.field.type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.LIST) {
      if (this.dynamicSelectList[0].id != "") {
        this.field.list = this.dynamicSelectList[0].id;
        this.field.state = true;
        this.field.schema["x-style"] = MIN_WIDTH_LIST_SMALL_FIELD;
      } else {
        Snackbar.popError(ERROR_NO_LIST_SELECTED);
        return;
      }
    }

    if (this.isEditingGroupField) {
      this.field.order = this.order;
      this.field.key = this.fieldsGroup[this.indexField].key;
      Vue.set(this.fieldsGroup, this.indexField, this.field);

      if (this.field.type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE) {
        this.editPhoneTypeList(this.field.key);
        this.field.schema["x-display"] = `custom-${this.field.key}`;
      } else {
        const foundIndex = this.phoneTypeList.findIndex(
          f => f.slot === `custom-${this.field.key}`
        );

        if (foundIndex >= 0) {
          this.phoneTypeList.splice(foundIndex, 1);
        }
      }
    } else {
      this.field.state = true;
      this.field.key = keyCode;
      if (this.field.type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE) {
        this.addPhoneTypeList(keyCode);
        this.field.schema["x-display"] = `custom-${this.field.key}`;
      }
      if (this.field.type == BASICO) {
        this.field.schema["x-style"] = MIN_WIDTH_BASIC_SMALL_FIELD;
      }
      this.fieldsGroup.push(this.field);
    }
    this.$emit(INFO_GROUP_EVENTS.CLOSE_MODAL_FIELD_GROUP);
  }

  @Watch("field", { deep: true })
  showFieldPreview() {
    if (!isNaN(Number(this.field.schema.minimum))) {
      this.maxValue = [
        (v: any): any => {
          return (
            (v && v > Number(this.field.schema.minimum)) ||
            `${FORM_TEMP_CONSTANTS.MESSAGE.MAX_VAL_FIELD} ${Number(
              this.field.schema.minimum
            )}`
          );
        }
      ];
      this.sliderMaxValueMinimum = Number(this.field.schema.minimum) + 1;
    } else {
      this.sliderMaxValueMinimum = 1;
    }
    if (!isNaN(Number(this.field.schema.maximum))) {
      this.minValue = [
        (v: any): any => {
          if (
            this.field.schema.maximum &&
            v >= Number(this.field.schema.maximum)
          ) {
            this.field.schema.maximum = Number(this.field.schema.minimum) + 1;
            this.inputSchemaMaximun();
          } else {
            if (
              this.field.schema.maximum &&
              !isNaN(Number(this.field.schema.minimum))
            ) {
              this.field.schema.maximum = Number(this.field.schema.maximum);
            }
          }
          return (
            (v &&
              (v < Number(this.field.schema.maximum) ||
                isNaN(Number(this.field.schema.maximum)))) ||
            `${FORM_TEMP_CONSTANTS.MESSAGE.MIN_VAL_FIELD} ${Number(
              this.field.schema.maximum
            )}`
          );
        }
      ];
    }

    this.schema.properties.field = this.setSchemaFields();
  }

  setSchemaFields(): Schema {
    const schema: Schema = {
      title: this.field.schema.title.trim(),
      type:
        this.field.schema.type === TYPE_BASE.DATE.DATA.value
          ? "string"
          : this.field.schema.type,
      "x-display": this.field.visualElement,
      format:
        this.field.schema.type === TYPE_BASE.DATE.DATA.value
          ? this.field.schema.type
          : "",
      description: this.field.uiSetup?.helpText?.trim(),
      "x-props": {
        prependIcon: this.field.uiSetup?.iconUrl
      },
      readOnly: !this.field.editable
    };
    if (!this.field.editable) {
      this.field.required = false;
      this.field.editableDashboard = false;
    }
    if (!this.field.visible) {
      this.field.editable = false;
    }
    if (this.field.type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.LIST) {
      schema["x-style"] = MIN_WIDTH_LIST_SMALL_FIELD;
      if (this.field.width == 4) {
        schema["x-class"] = "field-min-width-small";
      }
      if (this.field.width == 6) {
        schema["x-class"] = "field-min-width-mid";
      }
      if (this.field.width == 12) {
        schema["x-class"] = "field-min-width-big";
      }
    }
    if (
      this.field.type == BASICO &&
      schema["x-display"] == STRING_TYPE &&
      INPUT_TYPES.includes(schema.type) &&
      this.field.visualElement == "string"
    ) {
      if (this.field.width == 4) {
        schema["x-class"] = "field-min-width-small";
      }
      if (this.field.width == 6) {
        schema["x-class"] = "field-min-width-mid";
      }
      if (this.field.width == 12) {
        schema["x-class"] = "field-min-width-big";
      }
    }
    if (
      this.field.type == BASICO &&
      this.field.schema.type == TYPE_BASE.INTEGER.DATA.value
    ) {
      schema["maximum"] = TYPE_BASE.INTEGER.DEFAULT.MAXIMUM;
    } else {
      delete schema["maximum"];
    }
    schema["x-cols"] = { md: this.field.width };
    schema["x-options"] = {
      tooltipProps: { openOnHover: false, openOnClick: true, right: true }
    };

    if (this.field.type == FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE) {
      schema.type = "object";
      delete schema.description;
      delete schema["x-display"];
      //delete schema["x-props"];
      delete schema["x-cols"];
      delete schema["x-style"];
    }

    switch (this.field.visualElement) {
      case "slider":
        schema.minimum = this.field.schema.minimum;
        schema.maximum = this.field.schema.maximum;
        Object.assign(schema["x-props"], { "thumb-label": true });
        schema["x-step"] = this.field.schema["x-step"] || 1;
        break;
      case "radio":
        if (this.field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.LIST) {
          schema.oneOf = this.field.schema.oneOf || [];
        } else {
          schema.enum = this.field.schema.enum || this.enumValues;
        }
        schema["x-cols"] = { md: 4 };
        break;
      case "checkbox":
        schema.items =
          this.field.schema.items || this.field.type === BASICO
            ? { enum: this.enumValues, type: "string" }
            : { oneOf: this.listValues, type: "string" };
        if (this.field.required) schema.minItems = 1;
        schema["x-cols"] = { md: 4 };
        break;
      case "select":
        if (this.field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.LIST) {
          schema.oneOf = this.field.schema.oneOf;
          schema["x-itemIcon"] = "icon";
        } else {
          schema.enum = this.field.schema.enum;
        }

        Object.assign(schema["x-props"], {
          outlined: true,
          rounded: true,
          dense: true
        });
        break;
      case "string":
        Object.assign(schema["x-props"], {
          outlined: true,
          rounded: true,
          dense: true
        });
        break;
    }

    return schema;
  }

  addPhoneTypeList(keyCode: string) {
    this.phoneTypeList.push({
      slot: `custom-${keyCode}`,
      title: this.field.schema.title.trim(),
      model: "",
      countryCode: "",
      countryCallingCode: "",
      required: this.field.required,
      enabled: this.field.editable,
      formattedNumber: ""
    });
  }

  editPhoneTypeList(keyCode: string) {
    const foundIndex = this.phoneTypeList.findIndex(
      field => field.slot === `custom-${keyCode}`
    );

    if (foundIndex >= 0) {
      this.phoneTypeList[foundIndex].title = this.field.schema.title.trim();
      this.phoneTypeList[foundIndex].required = this.field.required;
      this.phoneTypeList[foundIndex].enabled = this.field.editable;
    } else {
      this.addPhoneTypeList(keyCode);
    }
  }

  @Watch("clearData")
  clearField() {
    this.field = {
      order: 0,
      type: "",
      list: "",
      key: "",
      conversationTitle: "",
      required: true,
      visible: true,
      editable: true,
      visualElement: "",
      uiSetup: {
        iconUrl: "",
        helpText: ""
      },
      schema: {
        title: "",
        type: ""
      },
      default: false,
      width: 12
    };
    this.enumValues = [];
    this.dynamicSelectList = [{ id: "", name: "" }];
    this.showMoreInfo = false;
  }

  @Watch("addFieldsKey")
  async loadListByName() {
    try {
      const filterQuery: ListQuery = { activeList: [STATE.ACTIVE] };

      const response = await this.listService.getChart(filterQuery);
      if (response.code === Http.Found && response.data !== undefined) {
        this.dynamicSelectConfig.listAll = (response.data[
          NAME_KEY_CHART.LIST_ARRAY
        ] as unknown) as DynamicSelectData[];
      } else {
        this.dynamicSelectConfig.listAll = [];
        Snackbar.popWarning(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  updateSelectList() {
    this.getData(this.dynamicSelectList[0].id);
  }

  async getData(id: string) {
    if (!id) return;
    const listValues: Array<ListSchema> = [];
    const enumValues: Array<string> = [];

    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.dynamicSelectList = [
          {
            id: id,
            name: responseData.data.name,
            state: responseData.data.state
          }
        ];

        this.dynamicSelectConfig.listAll.push({
          id: id,
          name: responseData.data.name
        });

        responseData.data.options.forEach((option: Option) => {
          const listHeader: ListSchema = {
            title: option.title,
            const: option.value,
            score: option.score
          };

          if (option.uiSetup.iconUrl !== "") {
            listHeader.icon = option.uiSetup.iconUrl;
          }

          listValues.push(listHeader);
          enumValues.push(option.title);
        });

        if (
          this.field.visualElement === FORM_TEMP_CONSTANTS.FIELD_TYPE.CHECKBOX
        ) {
          this.field.schema = {
            ...this.field.schema,
            items: {
              oneOf: listValues,
              type: FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
            }
          };
        } else {
          this.field.schema = {
            ...this.field.schema,
            oneOf: listValues
          };
        }

        this.listValues = listValues;
        this.enumValues = enumValues;
      } else {
        Snackbar.popWarning(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  @Watch("indexField")
  async fillFormFieldGroup() {
    this.cleanBeforeUse();

    if (this.isEditingGroupField) {
      this.field = _.cloneDeep(this.fieldsGroup[this.indexField]);
      this.dynamicSelectList = [{ id: this.field.list, name: "" }];
      this.order = this.field.order;

      if (this.field.list) {
        await this.getData(this.field.list);
      }

      if (!this.field.uiSetup) {
        this.field.uiSetup = { iconUrl: "", helpText: "" };
      }

      this.fieldGroupModalTitle = FIELD_GROUP_CONSTANTS.EDIT_FIELD_TITLE;

      await this.changeFieldType();
      this.changeElement();

      this.field.schema.type = this.field.schema.format
        ? TYPE_BASE.DATE.DATA.value
        : this.field.schema.type;
      this.schema.properties.field = this.field.schema;

      if (
        this.field.type == BASICO &&
        (this.field.schema.items?.enum || this.field.schema.enum)
      ) {
        this.enumValues =
          this.field.schema.items?.enum || this.field.schema.enum || [];
      }
    } else {
      this.fieldGroupModalTitle = FIELD_GROUP_CONSTANTS.ADD_FIELD_TITLE;
      this.resetForm();
    }
  }

  cancelAddField() {
    this.$emit(INFO_GROUP_EVENTS.CLOSE_MODAL_FIELD_GROUP);
  }

  inputSchemaMaximun() {
    if (this.field.schema.minimum && this.field.schema.maximum) {
      if (
        Number(this.field.schema.maximum) < Number(this.field.schema.minimum)
      ) {
        this.model = {
          "0": {
            field: Number(this.field.schema.maximum)
          }
        };
      } else {
        this.model = {
          "0": {
            field: Number(this.field.schema.minimum)
          }
        };
      }
    }
  }

  @Watch("field.type")
  createPhoneTypeListTemp() {
    if (this.field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE) {
      const phoneSchema: PhoneSchema = {
        slot: "field",
        title: this.field.schema.title.trim(),
        countryCode: "",
        countryCallingCode: "",
        required: this.field.required,
        enabled: this.field.editable,
        model: "",
        formattedNumber: ""
      };
      this.phoneTypeListTemp = [phoneSchema];
      return;
    }
    this.phoneTypeListTemp = [];
  }

  cleanOptions() {
    this.enumValues = [];
    this.field.schema.items = { enum: [], type: "string" };
    this.field.schema.oneOf = [];
    this.field.schema.enum = [];
  }

  @Watch("field.schema.title")
  @Watch("field.required")
  @Watch("field.editable")
  updatephoneTypeListTemp() {
    if (this.field.type === FIELD_GROUP_CONSTANTS.FIELD_TYPE.PHONE) {
      this.phoneTypeListTemp[0].title = this.field.schema.title.trim();
      this.phoneTypeListTemp[0].required = this.field.required;
      this.phoneTypeListTemp[0].enabled = this.field.editable;
    }
  }

  validateState() {
    if (this.dynamicSelectList.length > 0) {
      if (
        this.dynamicSelectList[0].state ||
        this.dynamicSelectList[0].state === undefined
      ) {
        return "";
      }
      return ELEMENT_VOIDED;
    }
    return "";
  }

  addElement() {
    this.$emit(FIELD_GROUP_CONSTANTS.ADD_ELEMENT_EMMIT);
  }
}
